module.exports = __webpack_public_path__ + "img/finance_3.34bf3e21.png";